import Card from "@rio-cloud/rio-uikit/Card";

interface KPIData {
  balance: number;
  totalExpenses: number;
  totalRevenue: number;
  profitMargin: number;
}

interface KPICardsProps {
  kpi?: KPIData | null;
}

const formatCurrency = (value?: number) => (value ?? 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 });

const formatProfitMargin = (margin: number): string => {
  // Backend já calcula: (lucroOperacional / receitaBruta) * 100
  return margin % 1 === 0 ? margin.toFixed(0) : margin.toFixed(2);
};

export default function KPICards({ kpi }: KPICardsProps) {
  const safeKpi = kpi ?? {
    balance: 0,
    totalExpenses: 0,
    totalRevenue: 0,
    profitMargin: 0,
  };

  // Usa o profitMargin calculado pelo backend (lucroOperacional / receitaBruta)
  const correctedProfitMargin = formatProfitMargin(safeKpi.profitMargin);

  return (
    <div className="display-grid grid-cols-4 gap-20 margin-bottom-20">
      <Card className="display-flex flex-column padding-20 gap-5">
        <span className="text-size-16">Saldo</span>
        <span className="text-size-h2 text-medium">R$ {formatCurrency(safeKpi.balance)}</span>
      </Card>

      <Card className="display-flex flex-row justify-content-between padding-20">
        <div className="display-flex flex-column gap-5">
          <span className="text-size-16">Despesa Total</span>
          <span className="text-size-h2 text-medium">R$ {formatCurrency(safeKpi.totalExpenses)}</span>
        </div>

        <div className="text-color-danger align-self-center">
          <span className="rioglyph rioglyph-arrow-down" style={{ fontSize: "50px" }} />
        </div>
      </Card>

      <Card className="display-flex flex-row justify-content-between padding-20">
        <div className="display-flex flex-column gap-5">
          <span className="text-size-16">Receita Total</span>
          <span className="text-size-h2 text-medium">R$ {formatCurrency(safeKpi.totalRevenue)}</span>
        </div>
        <div className="text-color-success align-self-center">
          <span className="rioglyph rioglyph-arrow-up" style={{ fontSize: "50px" }} />
        </div>
      </Card>

      <Card className="display-flex flex-column padding-20 gap-5">
        <span className="text-size-16">Margem de Lucro</span>
        <span className="text-size-h2 text-medium">{correctedProfitMargin}%</span>
      </Card>
    </div>
  );
}
